import React, { useEffect, useState } from 'react';
import { supabase } from '../../../../supabaseClient'; // Ajuste o caminho do client se necessário
import HeroBanner from '../HeroBanner';
import CategoryRow from '../CategoryRow';

export default function GamesContent({ onSelectVideo, handleViewAll }: any) {
  const [loading, setLoading] = useState(true);
  const [bannerVideos, setBannerVideos] = useState<any[]>([]);
  const [acaoGames, setAcaoGames] = useState<any[]>([]);
  const [aventuraGames, setAventuraGames] = useState<any[]>([]);
  const [rpgGames, setRpgGames] = useState<any[]>([]);
  const [terrorGames, setTerrorGames] = useState<any[]>([]);
  const [lutaGames, setLutaGames] = useState<any[]>([]);
  const [esporteGames, setEsporteGames] = useState<any[]>([]);
  const [tiroGames, setTiroGames] = useState<any[]>([]);
  const [outrosGames, setOutrosGames] = useState<any[]>([]);
  const [allGamesList, setAllGamesList] = useState<any[]>([]);

  useEffect(() => {
    async function fetchGamesData() {
      setLoading(true);
      try {
        // 🚀 CONSULTAS PARALELAS AO SUPABASE: Puxa estritamente os 10 mais recentes de cada categoria de jogos
        const [
          resBanner,
          resAcao,
          resAventura,
          resRpg,
          resTerror,
          resLuta,
          resEsporte,
          resTiro,
          resOutros,
          resAll
        ] = await Promise.all([
          supabase.from('videos').select('*').ilike('category', 'games%').not('is_short', 'eq', true).order('created_at', { ascending: false }).limit(5),
          supabase.from('videos').select('*').ilike('category', 'games:acao').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:aventura').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:rpg').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:terror').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:luta').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:esporte').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games:tiro').order('created_at', { ascending: false }).limit(10),
          supabase.from('videos').select('*').ilike('category', 'games%').not('is_short', 'eq', true).order('created_at', { ascending: false }).limit(20), // Segurança para variedades
          supabase.from('videos').select('*').ilike('category', 'games%').not('is_short', 'eq', true).order('created_at', { ascending: false }) // Para contagem total do Banner/Check
        ]);

        setBannerVideos(resBanner.data || []);
        setAcaoGames(resAcao.data || []);
        setAventuraGames(resAventura.data || []);
        setRpgGames(resRpg.data || []);
        setTerrorGames(resTerror.data || []);
        setLutaGames(resLuta.data || []);
        setEsporteGames(resEsporte.data || []);
        setTiroGames(resTiro.data || []);
        setOutrosGames(resOutros.data || []);
        setAllGamesList(resAll.data || []);

      } catch (err) {
        console.error("Erro ao carregar dados otimizados de games:", err);
      } finally {
        setLoading(false);
      }
    }

    fetchGamesData();
  }, []);

  if (loading) {
    return (
      <div style={{ textAlign: 'center', padding: '100px', color: '#888', fontSize: '16px' }}>
        Carregando mundo gamer...
      </div>
    );
  }

  const categoriasGames = [
    { title: '💥 Ação e Adrenalina', data: acaoGames },
    { title: '🗺️ Aventura e Exploração', data: aventuraGames },
    { title: '🛡️ RPG e Mundo Aberto', data: rpgGames },
    { title: '👻 Terror e Sobrevivência', data: terrorGames },
    { title: '🥊 Luta e Combate', data: lutaGames },
    { title: '⚽ Esportes e Corridas', data: esporteGames },
    { title: '🔫 Tiro (FPS)', data: tiroGames },
  ];

  return (
    <div>
      <HeroBanner videos={bannerVideos} onPlay={onSelectVideo} onInfo={onSelectVideo} />

      <div style={{ marginTop: '20px', position: 'relative', zIndex: 5, paddingBottom: '40px' }}>
        {allGamesList.length > 0 ? (
          <>
            {categoriasGames.map((cat, index) => {
              if (cat.data.length === 0) return null;

              return (
                <CategoryRow 
                  key={index} 
                  title={cat.title} 
                  videos={cat.data} // Já vem limitado a 10 otimizado do Supabase
                  onSelectVideo={onSelectVideo} 
                  onViewAll={() => handleViewAll(cat.title, cat.data)} 
                />
              );
            })}

            {outrosGames.length > 0 && (
              <CategoryRow 
                title="🎮 Mundo Gamer (Lançamentos e Variedades)" 
                videos={outrosGames} 
                onSelectVideo={onSelectVideo} 
                onViewAll={() => handleViewAll("🎮 Mundo Gamer", outrosGames)} 
              />
            )}
          </>
        ) : (
          <div style={{ textAlign: 'center', padding: '100px', color: '#888' }}>
            Nenhum conteúdo publicado na aba de Games ainda. Vá no painel e mande ver!
          </div>
        )}
      </div>
    </div>
  );
}